// -*-mode: rjsx -*-
// REACT
import React, { Component } from "react"
import PropTypes from "prop-types"
// eslint-disable-next-line
import clsx from "clsx"


// ROUTER
// eslint-disable-next-line
import { Link, Redirect } from "react-router-dom"

// MUI
// eslint-disable-next-line
import { makeStyles, withStyles } from "@material-ui/core/styles"
import CssBaseline from "@material-ui/core/CssBaseline"
import Typography from "@material-ui/core/Typography"
// eslint-disable-next-line
import Button from "@material-ui/core/Button"
// eslint-disable-next-line
import Favorite from '@material-ui/icons/Favorite';
// eslint-disable-next-line
import FavoriteBorder from '@material-ui/icons/FavoriteBorder'
import UncheckedCircle from '@material-ui/icons/RadioButtonUnchecked'
// import CheckedCircle from '@material-ui/icons/CheckCircleOutline';
import CheckedCircle from "@material-ui/icons/CheckCircle"
import Checkbox from '@material-ui/core/Checkbox'
import Fab from "@material-ui/core/Fab"
import DownIcon from "@material-ui/icons/KeyboardArrowDown"
import UpIcon from "@material-ui/icons/KeyboardArrowUp"
// eslint-disable-next-line
import HelpIcon from "@material-ui/icons/HelpOutline"
import grey from "@material-ui/core/colors/grey"
import Paper from "@material-ui/core/Paper"
import TextField from "@material-ui/core/TextField"
import {
    parseUrl,
    distinct,
    jsonPointerHas,
    deepCopy
} from "../Utils"
// BL
import { 
    readUserData,
    getContactsFromUserData,
    getIssuesFromUserData,
    getStatementsFromUserData,
    initDrives,
    manageDrives,
    handleDriveChange,
    genUrl
} from "../../bl/A/bl"




// UTILS
import * as _ from "lodash"

// FLASH
// eslint-disable-next-line
import FlashMessage from "./../FlashMessage.js"
import FlashTopBar from "../Flash/FlashTopBar.js"
import FlashHeader from "../Flash/FlashHeader.js"
// eslint-disable-next-line
import FlashSubHeader from "../Flash/FlashSubHeader.js"
//import FlashBottomBar from "../Flash/FlashBottomBar.js"
import FlashBottomPad from "../Flash/FlashBottomPad.js"
// LogRocket
// import LogRocket from 'logrocket'




// LOGGING SETUP
import appConfig from "./../../App.config.js"
// eslint-disable-next-line
const log = appConfig.getLogger("<Issues>")
//LogRocket.init('sbqpcc/flashdev')


const VARIATION = "A"

const styles = theme => ({ 
    //
    // GLOBAL STYLES START
    //

    //
    // APPBAR
    //
    appbarRoot: {
        ...theme.css.appbarRoot,
        // desktop - if more than 600
        [theme.breakpoints.up("md")]: {
            // backgroundColor: theme.palette.primary.dark,
        },
    },

    appbarMessage: {
        ...theme.css.appbarMessage
    },

    //
    // APPHEAD
    //
    appheadRoot: {
        ...theme.css.appheadRoot,
        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            height: theme.css.appheadRoot.mobile.height, // to accomodate for 2 line issues
        },
    },

    appheadMessage: {
        ...theme.css.appheadMessage,
    },
    
    bnavbarRoot: {
        ...theme.css.bnavbarRoot,
    },
    
    contentDiv: {
        ...theme.css.contentDiv,
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: theme.css.contentDiv.desktop.marginTop,
            maxWidth: theme.css.contentDiv.desktop.maxWidth,
        },
    },

    checkedCircle: {
        ...theme.css.checkedCircle
    },

    uncheckedCircle: {
        ...theme.css.uncheckedCircle
    },


    //
    // GLOBAL STYLES END
    //

/*
    // SCROLL FAB
    fab: {
        position: "fixed",
        bottom: theme.spacing(12),
        //        right: theme.spacing(1),
        left: "65%",
        zIndex: 10,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "60%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
*/
    continueButton: {
        margin: 20,
        padding: 8,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.light,
        },
    },

    backButton: {
        margin: 20,
        padding: 4,
        height: 30,
        fontSize: 11,
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover': {
            color: theme.palette.primary.contrastText,
            backgroundColor: theme.palette.primary.main,
        },
    },

    contactList: {
        margin: 0,
        marginTop: 0,
        // tab from the left
        padding: "0px",
        // inside the container
        width: "100%",
    },

    contactItem: {
        // gap between cards (individual items)
        margin: 0,
        // cursor: "pointer",
        borderRadius: 0, // default 4
    },

    //
    // new stuff
    //
    mainDiv: {
        // mobile
        marginTop: 0,
        marginBottom: 0,
        marginLeft: "auto",
        marginRight: "auto",
        padding: 0,
        paddingTop: 90,

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            paddingTop: 100,
	    maxWidth: 600,
//            marginBottom: 120,
        },

        color: theme.palette.test.mainFG,
        background: theme.palette.test.mainBG,
    },

    separatorDiv: {
        ...theme.css.separatorDiv,

        margin: 0 ,
        marginBottom: 0,
        borderRadius: 0,

        
        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            width: theme.css.separatorDiv.desktop.width,
            height: theme.css.separatorDiv.desktop.height,
            marginTop: theme.css.separatorDiv.desktop.marginTop, // separate sections
            marginLeft: theme.css.separatorDiv.desktop.marginLeft,
//            borderTopLeftRadius: 6,
//            borderTopRightRadius: 6,
        },
        
    },

    paperRoot: {
        // mobile
        margin: 0,
        maxWidth: "100%",
        padding: 10,
        paddingTop: 10,
        paddingBottom: 10,
//        maxHeight: 56,
        overflow: "hidden",
        cursor: "pointer",
        userSelect: "none",
        backgroundColor: "#FFFFFF",

        //
        // mobile
        //
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
            borderBottom: "1px solid",
            borderBottomColor: grey[200],
	    borderRadius: 0,
        },

        //
        // desktop - if more than 600
        //
        [theme.breakpoints.up("md")]: {
            marginTop: 15,
            borderRadius: 6,
        },
    },

    subheaderText: {
        fontSize: "1.25rem",
        fontWeight: 300,
        color: grey[800],
//        marginBottom: 5,
    },


    // SCROLL FAB
    fab: {
        position: "fixed",
        //        bottom: theme.spacing(12),
                bottom: theme.spacing(2),

        //        right: theme.spacing(1),
        //        left: "45%", // middle

        left: "83%", // middle

        zIndex: 500,
        
        //
        // desktop
        //
        [theme.breakpoints.up("md")]: {
            left: "75%",
        },

    },
    
    fabGreen: {
        color: theme.palette.common.white,
        backgroundColor: theme.palette.custom.scrollDark,
        '&:hover': {
            backgroundColor: theme.palette.custom.scrollLight,
        },
    },
    
})

class Issues extends Component {
    // TODO: refactor to use constructor
    constructor(props) {
        super(props)
        log.debug("constructor()")

        const {location, match} = this.props

        const initState =  {
            scrollerDirection: "down",
            redirectBack: false,
            redirectToStatements: false,
            isYourIssue: true,
            isYourIssueText: "",
            isYourIssueChecked: false,
            isYourIssueSubmitted: false
            //fakeDriveSlugs: ["ca-sd13-alpha-drive-dev2"],
        }

        const urlObj = parseUrl(location, match)

        log.debug("constructor(): urlObj =", urlObj)
        if(urlObj.drive) {
            log.debug("constructor(): YES, we have drive")
        } else {
            log.debug("constructor(): no, we don't have drive")
        }
        

        if(urlObj.drive) {
            initState.drive = urlObj.drive
            localStorage.setItem("drive", JSON.stringify(initState.drive))
        } else {
            localStorage.removeItem("drive")
        }

        this.state = initState

    }

    // we don't have continue here, we redirect on issue click
    /*
    handleContinueClick = () => {
        log.debug(" handleContinueClick()")
        // get all the checked contacts
        let checkedItems = _.filter(this.state.gl.issues, ["isChecked", true])
        log.debug(" handleContinueClick(): checkedItems = ", checkedItems)

        let localGL = this.state.gl
        localStorage.setItem("gl", JSON.stringify(localGL))
        log.debug(" handleContinueClick(): saved localGL")

        this.setState({redirectContinue: true})
    }
    */

    handleBackClick = () => {
        log.debug("handleBackClick()")
        log.debug("handleBackClick(): remove selected contacts")

        // do it in 2 stages on purpose, might be more interesting later
        // get checked contacts
        let checkedContacts = _.filter(this.state.gl.contacts, ["isChecked", true])
        log.debug("handleBackClick(): checkedContacts = ", checkedContacts)

        _.map(checkedContacts, (contact) =>{
            // uncheck if checked
            contact.isChecked ? contact.isChecked = false : contact.isChecked = true
        })

        log.debug("handleBackClick(): unchecked checkedContacts = ", checkedContacts)

        localStorage.setItem("gl", JSON.stringify(this.state.gl))
        
        this.setState({redirectBack: true})
    }



    handleYourIssueChange = () => {
        log.debug(`handleYourIssueChange()`)
        this.setState({isYourIssueSubmitted: true})
    }


    //
    // TODO: this is an effing mess that needs to be refactored
    //       but aggressively not spending time on this until 
    //       everything else is there
    // here we go directly to the issues after 1 click

    handleCheckboxChange = uuid => event => {
        log.debug(`handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)

        // don't rely on mutation
        const newGl = deepCopy(this.state.gl)

        // very special case is for your issue
        if(uuid === "your-issue-uuid") {
            newGl.issues = newGl.issues.filter(issue => issue.uuid !== "your-issue-uuid")
            this.setState({gl: newGl, isYourIssue: false})
            return
        }

        const item = newGl.issues.find(item => item.uuid === uuid)
        log.debug("handleCheckboxChange(): item = ", item)

        if(!item.isChecked) {
            // SET
            newGl.issues.forEach(issue => issue.isChecked = false)
            item.isChecked = true

            newGl.currentIssue = item // forward the latest/current issue
            localStorage.setItem("gl", JSON.stringify(newGl))

            this.setState({gl: newGl})

            const { history } = this.props
            history.push(genUrl(this)("/statements"))

        } else {
            // UNSET
            item.isChecked = false
            this.setState({gl: newGl})
        }
    }
                                           
    
    handleCheckboxChange_old = uuid => event => {
        log.debug(`handleCheckboxChange(): uuid = ${uuid}, event = ${event}`)
        let item = (_.filter(this.state.gl.issues, ["uuid", uuid]))[0]
        log.debug("handleCheckboxChange(): issue found = ", item)
        if(!item.isChecked) {

            // uncheck all the rest of them and their children
            let issues = this.state.gl.issues
            log.debug("handleCheckboxChange(): issues = ", issues)
            let checkedIssues = _.filter(issues, ["isChecked", true])
            log.debug("handleCheckboxChange(): checkedIssues = ", checkedIssues)

            let statements = this.state.gl.statements
            _.map(checkedIssues, issue => {
                issue.isChecked = false
                let issueStatements = _.filter(statements, ["issue.uuid", item.uuid])
                log.trace("handleCheckboxChange(): statements = ", statements)
                log.trace("handleCheckboxChange(): issueStatements = ", issueStatements)
                _.map(issueStatements, statement => statement.isChecked = false)
            })
            
            item.isChecked = true

            let localGL = this.state.gl
            localGL.currentIssue = item // forward the latest/current issue
            localStorage.setItem("gl", JSON.stringify(localGL))
            log.debug("handleCheckboxChange(): saved localGL")

            this.setState({redirectToStatements: true})
            
        } else {
            item.isChecked = false
            // clear out all the statements
            let statements = this.state.gl.statements
            let issueStatements = _.filter(statements, ["issue.uuid", item.uuid])
            log.trace("handleCheckboxChange(): statements = ", statements)
            log.trace("handleCheckboxChange(): issueStatements = ", issueStatements)
            _.map(issueStatements, statement => statement.isChecked = false)

            let localGL = this.state.gl
            localGL.currentIssue = item // forward the latest/current issue
            localStorage.setItem("gl", JSON.stringify(localGL))
            log.debug("handleCheckboxChange(): saved localGL")
        }
        
        log.debug("handleCheckboxChange(): item.isChecked = ", item.isChecked)
        
        this.setState({gl: this.state.gl})
    }

    
    componentWillUnmount  = () => {
        window.removeEventListener("scroll", this.handleScroll)
    }

    handleReadUserDataResult = (result) => {
        log.debug("<Issues>: handleReadUserDataResult(): result = ", result)
        const userData = result.data.user

        const newGl = {}
        newGl.user = {
            ...userData,
            geo: {
                ...userData.geo,
                address: {
                    ...userData.geo.address,
                    zipPlus4: `${userData.geo.address.zip.code}-${userData.geo.address.zip.plus4}`
                }
            }
        }
        // NEXT: make sure that checked 
        
        // newGl.contacts = getContactsFromUserData(userData)
        //newGl.contacts = this.state.gl.contacts // don't change th contacts as some of them are checked
        //                                                // from the previous screen

        newGl.contacts = getContactsFromUserData(userData)        
        newGl.issues = getIssuesFromUserData(userData)
        newGl.statements = getStatementsFromUserData(userData)
        log.debug("<Issues>: handleReadUserDataResult(): newGl.contacts = ", newGl.contacts)
        log.debug("<Issues>: handleReadUserDataResult(): newGl.issues = ", newGl.issues)
        log.debug("<Issues>: handleReadUserDataResult(): newGl.statements = ", newGl.statements)

        manageDrives(this)(newGl.statements)
        
        // get the checked contacts from the localGl for now
        let savedGl = JSON.parse(localStorage.getItem("gl"))

        // all levels that we got from the db, this should be the default
        const allLevels = distinct(newGl.contacts, contact => `${contact.level}`)
        log.debug("handleReadUserDataResult(): allLevels = ", allLevels)
        const levels = allLevels
        log.debug("handleReadUserDataResult(): levels = ", levels)


        // select issue that we have saved as selection if it does exist
        if(savedGl) {
            const savedSelectedIssue = savedGl.issues.find(issue => issue.isChecked)
            log.debug("handleReadUserDataResult(): savedSelectedIssue = ", savedSelectedIssue)
            if(savedSelectedIssue) {
                const issueToSelect = newGl.issues.find(issue => issue.slug === savedSelectedIssue.slug)
                log.debug("handleReadUserDataResult(): issueToSelect = ", issueToSelect)
                if(issueToSelect) {
                    issueToSelect.isChecked = true
                }
            }
        }

        this.setState({
            levels: levels,
            user: newGl.user,
            gl: newGl
        })
        
    }

    handleReadUserDataError = (error) => {
        log.debug("<Issues>: handleReadUserDataError(): error = ", error)
        this.setState({redirectToRegister: true })  
    }

    handleBarChange = (change) => (event) => {
        log.debug("handleBarChange(): change = ", change)
        log.debug("handleBarChange(): event = ", event)
        switch(change.widget) {
        case "drive":
            handleDriveChange(this)(change)
            break
        default:
        }
    }

    componentDidMount = () => {
        window.addEventListener("scroll", this.handleScroll)
        this.scrollToTop()

        const savedUser = JSON.parse(localStorage.getItem("user"))
        if(!savedUser) {
            this.setState({...this.state, redirectToRegister: true })            
            return
        }

        const user = {
            email: savedUser.email
        }


        this.setState({
            scrollerDirection: "down",
//            levels: levels,
//            gl: localGL,

            variation: {
                current: VARIATION,
                A: "/issues/a",
                B: "/issues/b"
            },
            ...initDrives(this)
            
        })

	readUserData(savedUser, {
	    onResult: this.handleReadUserDataResult,
	    onError: this.handleReadUserDataError
	})


        /*
        const savedDrive = JSON.parse(localStorage.getItem("drive"))


        let localGL = JSON.parse(localStorage.getItem("gl"))
        //const savedUser = JSON.parse(localStorage.getItem("user"))
        
        log.debug("componentWillMount(): localGL = ", localGL)
        log.debug("componentWillMount(): savedDrive = ", savedDrive)


        let checkedContacts = _.filter(localGL.contacts, ["isChecked", true])
        log.debug("componentWillMount(): checkedContacts = ", checkedContacts)
        let levels = _.reduce(checkedContacts, (result, value) => {
            log.debug("componentWillMount(): result = ", result)
            log.debug("componentWillMount(): value = ", value)
            result[value.level] = true
            return result
        }, {})


        _.map(localGL.statements, (statement) => {
            statement.isChecked = false
        })


        this.setState({
            scrollerDirection: "down",
            levels: levels,
            gl: localGL,

            variation: {
                current: VARIATION,
                A: "/issues/a",
                B: "/issues/b",
                ...initDrives(this)
            },
        })


        
	readUserData(savedUser, {
	    onResult: this.handleReadUserDataResult,
	    onError: this.handleReadUserDataError
	})
        */

    }
    

    handleScroll = (event) => {
        log.trace("<Issues>: handleScroll(): event = ", event)

        if(!this.state.scrollerDirection) {
            this.setState({scrollerDirection: "down"})
            return
        }

        const windowHeight = "innerHeight" in window ? window.innerHeight : document.documentElement.offsetHeight;
        const body = document.body;
        const html = document.documentElement;
        const docHeight = Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight,  html.scrollHeight, html.offsetHeight);
        const windowBottom = windowHeight + window.pageYOffset;

        log.trace("handleScroll(): window.pageYOffset =", window.pageYOffset)

        if (windowBottom >= (docHeight - 1)) {
            this.setState({scrollerDirection: "up"})
        } else if(window.pageYOffset === 0) {
            this.setState({scrollerDirection: "down"})
        }
    }

    scrollToBottom = () => {
        log.debug("<Issues>: scrollToBottom(): this.contentDivEl = ", this.contentDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        if(this.tailDivEl) {
            this.tailDivEl.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    }


    scrollToTop = () => {
        log.debug("<Issues>: scrollToBottom(): this.headDivEl = ", this.headDivEl)
        log.debug("<Issues>: scrollToBottom(): this.tailDivEl = ", this.tailDivEl)
        
        if(this.headDivEl) {
            this.headDivEl.scrollIntoView({
                behavior: "smooth",
                block: "start",
            })
        }
    }
    

    render() {
        const { classes, match, history } = this.props

        log.debug("<Issues>: render(): history = ", history)

        /*
          // we need to remove "issues" here
        const { driveSlug } = this.props.match.params
        if(!driveSlug) {
            return(<Redirect push to={"/drives/all/issues"}/>)
        }
        */

        const { driveSlug } = this.props.match.params
        if(!driveSlug) {
            //history.push("/drives/all/issues")
            history.replace("/drives/all/issues")
        }


        // redirects first
        if (this.state.redirectBack) {
            return <Redirect push to="/contacts"/>
        } else if(this.state.redirectToStatements) {
            let nextUrl = "/statements"
            // we don't custom the statements for the drive yet
            //
            //if(this.state.drive) {
            //nextUrl = "/drive/" + this.state.drive.name + nextUrl
            //}
            
            log.debug("render(): nextUrl =", nextUrl)
            return <Redirect push to={"/statements"}/>
        }


        if(!this.state.gl) {
            log.debug("render(): no state.gl = ", this.state)
            log.debug("render(): no so gracefully loading...")
            // return (<div></div>)

            return (<React.Fragment>
                      <div ref={(el) => { this.headDivEl = el; }} ></div>
                      <Typography variant="h6">
                        Loading...
                      </Typography>
                    </React.Fragment>)
        }
        
        // drive processing
        const { statements, issues } = this.state.gl
        let items = issues
        
        log.debug("render(): before filter statements = ", statements)
        if(jsonPointerHas(this.state, "/drive/slug")
           && this.state.drive.slug !== "all") {

            const driveStatements = statements
                  .filter(statement => statement.drive
                          && statement.drive.slug === this.state.drive.slug)

            log.debug("render(): driveStatements = ", driveStatements)
            const driveIssues = issues.filter(issue => {
                return driveStatements.find(statement => statement.issue.slug === issue.slug) ? true : false
            })
            log.debug("render(): driveIssues = ", driveIssues)
            items = driveIssues
        }

        let user = this.state.gl.user


        /*
        if(this.state.isYourIssue && !issues.find(issue => issue.uuid === "your-issue-uuid")) {
            const yourIssue = {
                "slug": "your-issue-slug",
                "uuid": "your-issue-uuid",
                "txt": this.state.isYourIssueText,
                "level": "state",
                isYourIssue: true,
                isChecked: false
            }
            items.push(yourIssue)
        }
        */


        log.debug("render(): items = ", items)
        
        // some precounts of city items
        let cityItems = _.filter(items, ["level", "city"])
        log.debug("render(): cityItems = ", cityItems)
        let cityIssueCount
        // we can take the first contact in that section
        // and grab the count there, each contact has
        // the number if "their" issues recalculated
        // and it should be equal for all contacts in that section
        if(cityItems) {
            cityIssueCount = cityItems.length
        } else {
            cityIssueCount = 0
        }
        log.debug("render(): cityIssueCount = ", cityIssueCount)


        let countyItems = _.filter(items, ["level", "county"])
        log.debug("render(): countyItems = ", countyItems)

        let stateItems = _.filter(items, ["level", "state"])
        log.debug("render(): stateItems = ", stateItems)

        let federalItems = _.filter(items, ["level", "federal"])
        log.debug("render(): federalItems = ", federalItems)

        
        let nums = []
        for (let i = 1; i <= 100; i++) {
            nums.push(i)
        }


        let headerText1 = "Show your Representative an issue that's important to you"
        let subheaderDiv =
            <div>
              <Typography className={classes.subheaderText} variant="h6" display="inline">
                Select an issue. The
              </Typography>
              <Typography className={classes.subheaderText} variant="h6" style={{fontStyle:"italic"}} display="inline">
                  &nbsp;current
              </Typography>
              <Typography className={classes.subheaderText} variant="h6" display="inline">
                &nbsp;hot issues are:
              </Typography>
            </div>
        
        let separatorText = []
        separatorText.push("Federal")
        
        //
        // Add your issue 
        //
        //let stateItems = _.filter(items, ["level", "state"])
        //        log.debug("render(): stateItems = ", stateItems)
        // yourissue
        /*
        if(true) {
            let yourIssue = {
                uuid: "yourIssue-uuid",
                slug: "yourIssue-slug",
                txt: "",
                //issue: this.state.gl.currentIssue,
                //isChecked: true,
                rate: 0,
                isChecked: false,
                isYourIssue: true
            }
            //if(!this.state.drive) {
            stateItems.push(yourIssue)
            //            }
        }
        */

        //
        // Drive processing
        //
        /*
        log.debug("render(): this.state.drive = ", this.state.drive)
        if(jsonPointerHas(this, "/state/fakeDriveSlugs")
           && jsonPointerHas(this, "/state/drive/slug")) {
            if(this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                log.debug("render(): YES include")
            } else {
                log.debug("render(): NO include")
            }
        }
        */

        // NEXT here we don't really need to do this, we just need to select issues
        // at are both of these levels and part of the state
        /*
        log.debug("render(): dude: start")
        if(jsonPointerHas(this.state, "/fakeDriveSlugs")
           && jsonPointerHas(this.state, "/drive/slug")) {
            log.debug("render(): dude: attr")
            if(this.state.fakeDriveSlugs.includes(this.state.drive.slug)) {
                log.debug("render(): dude: is fake drive")
            } else if(this.state.drive.slug === "all") {
                log.debug("render(): dude: not fake drive but is all")
            } else {
                log.debug("render(): dude: lame drive")
                // fake some action here
                federalItems = []
                stateItems = []
                countyItems = []
                cityItems = []
            }
        }
        */

        // this is somewhat of an override of the same code in handleReadUserDataResult
        // we need to revisit this after we do the "land on issues" code
        
        console.log("FIXME: this.state.levels =", this.state.levels)
        const savedGl = JSON.parse(localStorage.getItem("gl"))

        /*
        const checkedContacts = savedGl.contacts.filter(contact => {
            return contact.isChecked
        })
        */

        // check all contacts by default now
        const checkedContacts = savedGl.contacts.map(contact => {
            contact.isChecked = true
            return contact
        })

        console.log("FIXME: savedGl =", savedGl)
        console.log("FIXME: checkedContacts =", checkedContacts)

        let levels = distinct(checkedContacts, contact => `${contact.level}`)

        console.log("FIXME: levels =", levels)

        if(!levels) levels = this.state.levels


        /*
        // this is a duplicate, we should have better logic, but just stick it here
        // and assign the first level we have availabel
        if(this.state.isYourIssue && !issues.find(issue => issue.uuid === "your-issue-uuid")) {
            const yourIssue = {
                "slug": "your-issue-slug",
                "uuid": "your-issue-uuid",
                "txt": this.state.isYourIssueText,
                "level": levels[0],
                isYourIssue: true,
                isChecked: false
            }
            items.push(yourIssue)
        }
*/

	return(
            <React.Fragment>
	      <CssBaseline/>
              
              <div ref={(el) => { this.headDivEl = el; }} ></div>
              
              <FlashTopBar text="Hot Issues"
                           variation={this.state.variation}
                           drives={this.state.drives}
                           history={this.props.history}
                           match={this.props.match}
                           onChange={this.handleBarChange}
                
              />

              <div className={classes.mainDiv}>
                <FlashHeader text={headerText1}/>

                <div style={{marginTop: 20, marginBottom: 10, marginRight: 25, marginLeft: 25}}>
                  {subheaderDiv}
                </div>
                {/*
                <FlashSubHeader style={{marginBottom: 100}} text1={
                    <div style={{
                        display: "flex",
                        alignItems: "center",
                        width: 400,
                    }}>
                        <Typography variant="h6">
                          Click on the box to select an issue
                        </Typography>
                      <div style={{}}>
                        <HelpIcon style={{fontSize: 30, color: grey[500], paddingTop: 0, marginLeft: 5,}}/>
                      </div>
                    </div>
                }>
                  <Typography className={classes.subheaderText} variant="h6" style={{fontSize: 18, marginLeft: 10 }}>
                    <div style={{display: "inline", fontWeight: 400}}>We'll find the issues they cover</div>
                  </Typography>
                </FlashSubHeader>
                 */}
                

                
                {
                    //
                    // Federal
                    //
                }
                { levels.includes("federal")
                  && federalItems.length > 0
                  &&
                  <div>
                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {separatorText[0]}
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {federalItems.map((value, index) => (
                      <Paper className={classes.paperRoot} key={index}>
                      {!value.isYourIssue &&
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                              {value.txt}
                            </Typography>
                          </div>
                          <Checkbox
                            icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                            checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                            onChange={this.handleCheckboxChange(value.uuid)}
                            checked={value.isChecked}
                          />
                       </div>
                      }
                        
                        {value.isYourIssue &&                            
                         <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                           <div>
                             <TextField style={{marginTop: "23px", marginLeft: 20, fontSize: 18, fontWeight: 400, width: "470px" }}
                                        id={`yourIssue-id`}
                                        size="small"
                                        label="Your Issue"
                                        variant="outlined"
                                        helperText="Feel free to suggest! (20 letters max)"
                                        value={this.state.isYourIssueText}
                                        onChange={({target}) => {
                                            //console.log("target.value = ", target.value)
                                            if(target.value.length < 20) {
                                                this.setState({isYourIssueText: target.value})
                                            }
                                        }}
                             />
                           </div>
                           <Checkbox
                         //disabled={false}
                         //    icon={<UncheckedCircle style={{color: "#cccccc"}}className={classes.uncheckedCircle}/>}
                             icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                             checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                             onChange={this.handleCheckboxChange(value.uuid)}
                             checked={value.isChecked}
                           />
                         </div>
                        }
                        
                      </Paper>
                  ))}
                  </ul>
                  </div>
                }

                {
                    //
                    // State
                    //
                }
                { levels.includes("state")
                  && stateItems.length > 0
                  &&
                  <div>
                    <div className={classes.separatorDiv}>
                      <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                        {/* State */}
                        {user.geo.address.state.name}
                      </Typography>
                    </div>
                
                    <ul className={classes.contactList}>
                      {stateItems.map((value, index) => (
                          <Paper className={classes.paperRoot} key={index}>
                            {!value.isYourIssue &&                            
                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                               <div>
                                 <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                                   {value.txt}
                                 </Typography>
                               </div>
                               <Checkbox
                                 icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                 checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                 onChange={this.handleCheckboxChange(value.uuid)}
                                 checked={value.isChecked ? value.isChecked : false}
                               />
                             </div>
                            }

                            {value.isYourIssue &&                            
                             <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                               <div>
                                 <TextField style={{marginTop: "23px", marginLeft: 20, fontSize: 18, fontWeight: 400, width: "470px" }}
                                            id={`yourIssue-id`}
                                            size="small"
                                            label="Your Issue"
                                            variant="outlined"
                                            helperText="Feel free to suggest! (20 letters max)"
                                            value={this.state.isYourIssueText}
                                            onChange={({target}) => {
                                                //console.log("target.value = ", target.value)
                                                if(target.value.length < 20) {
                                                    this.setState({isYourIssueText: target.value})
                                                }
                                            }}
                                 />
                               </div>
                               <Checkbox
                             //disabled={false}
                             //    icon={<UncheckedCircle style={{color: "#cccccc"}}className={classes.uncheckedCircle}/>}
                                 icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                                 checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                                 onChange={this.handleCheckboxChange(value.uuid)}
                                 checked={value.isChecked}
                               />
                             </div>
                            }
                            
                          </Paper>
                      ))}
                    </ul>
                  </div>
                }

                {
                    //
                    // County
                    //
                }

            { levels.includes("county") && countyItems.length > 0 &&
              <div>
                <div className={classes.separatorDiv}>
                  <Typography variant="subtitle1" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {/* County */}
                    {user.geo.county.name}
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {countyItems.map((value, index) => (
                      <Paper className={classes.paperRoot} key={index}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                              {value.txt}
                            </Typography>
                          </div>
                          <Checkbox
                            icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                            checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                            onChange={this.handleCheckboxChange(value.uuid)}
                            checked={value.isChecked}
                          />
                      </div>
                      </Paper>
                  ))}
                </ul>
              </div>
            }

                

                {
                    //
                    // City
                    //
                }

                { levels.includes("city") && cityItems.length > 0 &&
                  <div>
                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    {/* City */}
                    {user.geo.address.city.name}
                  </Typography>
                </div>
                
                <ul className={classes.contactList}>
                  {cityItems.map((value, index) => (
                      <Paper className={classes.paperRoot} key={index}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between"}}>
                          <div>
                            <Typography variant="subtitle2"style={{marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                              {value.txt}
                            </Typography>
                          </div>
                          <Checkbox
                            icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                            checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                            onChange={this.handleCheckboxChange(value.uuid)}
                            checked={value.isChecked}
                          />
                      </div>
                      </Paper>
                  ))}
                  </ul>
                  </div>
                }



                <div className={classes.separatorDiv}>
                  <Typography variant="h6" color="inherit" display="inline" style={{ fontSize: 22, fontWeight: 500 }}>
                    Add Your Issue
                  </Typography>
                </div>

                <Paper className={classes.paperRoot} key={"some-index"}>
            {!this.state.isYourIssueSubmitted &&
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "-10px"}}>
                    <div>
                      <TextField style={{marginTop: "23px", marginLeft: 20, fontSize: 18, fontWeight: 400, width: "545px" }}
                                 id={`yourIssue-id`}
                                 size="small"
                                 label="Your Issue"
                                 variant="outlined"
                                 helperText="Add your issue (up to 20 characters)"
                                 value={this.state.isYourIssueText}
                                 onChange={({target}) => {
                                     console.log("target.value = ", target.value)
                                     if(target.value.length < 20) {
                                         this.setState({isYourIssueText: target.value})
                                     }
                                 }}
                                 onKeyPress={(ev) => {
                                     //console.log(`Pressed keyCode ${ev.key}`);
                                     if (ev.key === 'Enter') {
                                         // Do code here
                                         this.handleYourIssueChange()
                                         ev.preventDefault();
                                     }
                                 }}
                      />
                    </div>
             {/*
                    <Checkbox
                      icon={<UncheckedCircle className={classes.uncheckedCircle}/>}
                      checkedIcon={<CheckedCircle className={classes.checkedCircle}/>}
                      onChange={this.handleYourIssueChange}
                      checked={this.state.isYourIssueChecked}
                    />
              */}
             </div>
            }

            {this.state.isYourIssueSubmitted &&
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginTop: "-10px"}}>
                    <div>
                      <Typography variant="subtitle2"style={{paddingTop: 30, minHeight: 87, marginLeft: 20, fontSize: 18, fontWeight: 400 }}>
                        Issues with frequent mention will be posted
                      </Typography>
                    </div>
             </div>
            }

                  
                </Paper>
              </div>

              

            {/*
              <FlashBottomBar
                backButton={{
                    text: "BACK",
                    link: "/contacts",
//                    onClick: this.handleNext,
//                    onError: this.handleError,
                }}
              />
             */}


              { this.state.scrollerDirection && this.state.scrollerDirection === "down" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToBottom}>
                  <DownIcon style={{fontSize: 50}}/>
                </Fab>
              }

              { this.state.scrollerDirection && this.state.scrollerDirection === "up" &&
                <Fab aria-label="scroll"
                     className={clsx(classes.fab, classes.fabGreen)}
                     onClick={this.scrollToTop}>
                  <UpIcon style={{fontSize: 50}}/>
                </Fab>
              }
              
              
              <FlashBottomPad
                backButton={{
                    text: "BACK",
                    link: genUrl(this)("/contacts")
                }}
              />

              <div ref={(el) => { this.tailDivEl = el; }} ></div>

            </React.Fragment>
	)
    }
}

Issues.propTypes = {
    classes: PropTypes.object.isRequired,
}

export default withStyles(styles, { name: "Issues" })(Issues)

